"use client"

import { AdyenDropInScript } from "@/app/(site)/[locale]/checkout/centra/paymentScripts/AdyenDropInScript"
import { type PaymentMethodErrorCallback } from "@/app/(site)/[locale]/checkout/CheckoutContent/Steps/Payment"
import { useRef } from "react"

export interface AdyenDropInProps {
    onLoaded: () => void
    onError: PaymentMethodErrorCallback
    langCode: string
}

export default function AdyenDropIn({
    onLoaded = () => {},
    onError = () => {},
    langCode
}: AdyenDropInProps) {
    const htmlAdyenDropInReference = useRef<HTMLDivElement>(null)
    return (
        <>
            <div
                className="adyen-drop-in-container"
                id="adyen-drop-in-container"
                ref={htmlAdyenDropInReference}
            />

            <AdyenDropInScript
                onLoaded={onLoaded}
                onError={onError}
                htmlAdyenDropInReference={htmlAdyenDropInReference}
                langCode={langCode}
            />
        </>
    )
}
